module.exports = __webpack_public_path__ + "static/media/Feature-1.78f8fb0c.svg";